import { gql } from '@apollo/client';
import COMPONENT_COLORS_AND_SIZES from 'api/fragments/COMPONENT_COLORS_AND_SIZES';
const GET_SPECIFICATION_PREVIEW_COMPONENTS = gql `
  ${COMPONENT_COLORS_AND_SIZES}
  query GetSpecificationPreviewComponents($modelSpecificationId: ID!) {
    node(id: $modelSpecificationId) {
      ... on ModelSpecificationNode {
        id
        state
        components {
          edges {
            node {
              id
              photo
              name
              isConsumptionSet
              piecesPerMarker
              consumptionVariedOnSize
              hasOneVariantColorForAllSpecificationColors
              hasOneVariantSizeForAllSpecificationSizes
              variantColorForAllSpecificationColors
              variantSizeForAllSpecificationSizes
              ...ComponentColorsAndSizesFragment
              productSnapshot {
                id
                name
                productDescription
                supplierFullName
                supplierShortName
                width
                componentSize
                composition
                zipperType
                grammage
                producerCode
                underSliderType
                upperSliderType
                yardage
                image
                variantSnapshots {
                  edges {
                    node {
                      id
                      color
                      size
                    }
                  }
                }
                product {
                  id
                  name
                  status
                  pictures {
                    edges {
                      node {
                        id
                        image
                      }
                    }
                  }
                  zipperType {
                    id
                    name
                    upperSlider
                    underSlider
                  }
                  grammage {
                    id
                    name
                  }
                  componentSize {
                    id
                    name
                  }
                  width {
                    id
                    name
                  }
                  composition {
                    id
                    name
                  }
                  producerCode {
                    id
                    name
                  }
                  underSliderType {
                    id
                    name
                  }
                  upperSliderType {
                    id
                    name
                  }
                  yardage {
                    id
                    name
                  }
                }
              }
              consumptions {
                edges {
                  node {
                    id
                    consumption
                    modelSpecificationSize {
                      id
                      sizeName {
                        id
                        name
                      }
                    }
                  }
                }
              }
              productCategory {
                id
                type
                typeLabelPL
                typeLabelEN
                typeIcon
                hasName
                hasComposition
                hasComponentSize
                hasSupplier
                hasProductDescription
                hasWidth
                hasPiecesPerMarker
                hasZipperType
                variantHasColor
                variantHasChainColor
                variantHasTapeColor
                variantHasSliderColor
                variantHasSize
                hasGrammage
                hasUpperSliderType
                hasUnderSliderType
                hasProducerCode
                hasYardage
                colorAutoCalculationMethod
                consumptionType {
                  id
                  name
                  labelPL
                  labelEN
                  integerValues
                }
              }
            }
          }
        }
      }
    }
  }
`;
export default GET_SPECIFICATION_PREVIEW_COMPONENTS;
